module.exports = __webpack_public_path__ + "img/thumbnail_BorneanElephant_f_albino.4c9c9b67.png";